module.exports = __webpack_public_path__ + "static/banner-bg-7492bb6d1694b5637dc914c823d1d88d.jpg";